import squareBg from "./assets/img/square.png";
import squareBgWhite from "./assets/img/square_white.png";
import grassBg from "./assets/img/grass.png";
import dirtBg from "./assets/img/dirt.png";
import squareBgRed from "./assets/img/square_red.png";
import squareScreening from "./assets/img/square_screening.png";
import squareBgGreen from "./assets/img/square_green.png";
import squareBgBlue from "./assets/img/square_blue.png";
import squareBgYellow from "./assets/img/square_yellow.png";
import squareBgYellowLight from "./assets/img/square_yellow_light.png";
import squareGray from "./assets/img/square_gray.png";
import squareOrange from "./assets/img/square_orange.png";
import squareOrangeDark from "./assets/img/square_orange_dark.png";
import squareGrayLight from "./assets/img/square_gray_light.png";
import squarePurple from "./assets/img/square_purple.png";
import squareAzure from "./assets/img/square_azure.png";
import squareBrown from "./assets/img/square_brown.png";

export const textures = [
  {
    prop: 'squareDefault',
    path: squareBg
  },
  {
    prop: 'squareBgWhite',
    path: squareBgWhite
  },
  {
    prop: 'grass',
    path: grassBg
  },
  {
    prop: 'dirt',
    path: dirtBg
  },
  {
    prop: 'squareRed',
    path: squareBgRed
  },
  {
    prop: 'squareScreening',
    path: squareScreening
  },
  {
    prop: 'squareGreen',
    path: squareBgGreen
  },
  {
    prop: 'squareBlue',
    path: squareBgBlue
  },
  {
    prop: 'squareYellow',
    path: squareBgYellow
  },
  {
    prop: 'squareBgYellowLight',
    path: squareBgYellowLight
  },
  {
    prop: 'squareGray',
    path: squareGray
  },
  {
    prop: 'squareOrange',
    path: squareOrange
  },
  {
    prop: 'squareOrangeDark',
    path: squareOrangeDark
  },
  {
    prop: 'squareGrayLight',
    path: squareGrayLight
  },
  {
    prop: 'squarePurple',
    path: squarePurple
  },
  {
    prop: 'squareAzure',
    path: squareAzure
  },
  {
    prop: 'squareBrown',
    path: squareBrown
  },
];
